module.exports = __webpack_public_path__ + "webstatic/img/defaultImg.5f3a45b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/defaultImg.jpg
// module id = +qNE
// module chunks = 3